import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Step from './Step';

import { Flex, Box } from '../../../units/Box/Box';

const Line = styled(Box)`
  background: ${props =>
    props.active ? props.theme.colors.brand : props.theme.colors.greyLight};
  flex-basis: 227px;
  flex-shrink: 0;
  height: 1px;
`;

const LineToNextStep = ({ active }) => {
  return <Line active={active} />;
};

LineToNextStep.propTypes = {
  active: PropTypes.bool.isRequired
};

class Steps extends Component {
  static propTypes = {
    steps: PropTypes.array.isRequired,
    activeStep: PropTypes.number.isRequired
  };

  renderSteps = (steps, activeStep) => {
    const elements = [];

    steps.forEach((step, key) => {
      elements.push(<Step {...step} key={key} activeStep={activeStep} />);

      const isPassedStep = activeStep > step.step;

      if (key < steps.length - 1) {
        elements.push(
          <LineToNextStep active={isPassedStep} key={`line${key}`} />
        );
      }
    });

    return elements;
  };

  render() {
    const { steps, activeStep } = this.props;

    return (
      <Flex
        className="registation-steps"
        justify="center"
        align="center"
        width="629px"
      >
        {this.renderSteps(steps, activeStep)}
      </Flex>
    );
  }
}

export default Steps;



// WEBPACK FOOTER //
// ./src/components/containers/NewClient/RegistrationSteps/RegistrationSteps.js